<template>
  <div class="no-padding">
    
    <div
      :class="['box', { 'selected-box': ( selected ) }]"
      @click="toggleSelection()"
    >
      <div class="box-header">
        <label class="exp-checkbox-label" @click.stop>
          <input
            type="checkbox"
            v-model="selected"
            @click.stop
          />
          <span class="exp-checkbox-custom"></span>

          <div v-if="editable" class="editable-container" @click="clicked_edit">
            <span class="exp-checkbox-text" v-html="rendered_html"></span>
          </div>
          <div v-else>
            <span class="exp-checkbox-text" v-html="rendered_html"></span>
          </div>

        </label>
      </div>
    </div>

  </div>
</template>

<script>
import { randomstr } from '@/core/services/deviceId';
import { is_event_inside_element_with_id } from '@/core/services/editor.helper.js';


export default {
  name: 'QuestionCheckboxOptionRow',
  props: ['row','editable','index'],
  emits: ['selected','edit_clicked'],
  computed: {
    rendered_html() {
      if (!this.row) {
        console.error('row not set');
      }

      return this.row.text || this.row.name;
    },
    editor_id() {
      return `edit-row-${this.local_id}`;
    },
    
  },

  watch: {
    row: {
      deep: true,
      handler() {
        if (!this.row) {
          console.error('row not set');
        }
        
        this.selected = false;
        this.local_text = this.row.text || this.row.name;
      }
    },
    
    selected: {
      deep: true,
      handler() {

        this.$emit('selected', this.row, this.selected, this.input_text);

        if (this.selected) {
          const unlock_text = this.row.unlock_text;

          this.show_text = !!unlock_text;
        }
        else {
          this.show_text = false;
        }
      }
    }
  },

  mounted() {
    if (this.editable) {
      document.addEventListener('mousedown', this.handle_click_outside);
    }
    
    this.local_id = randomstr(8);
    this.selected = false;
  },
  beforeDestroy() {
    if (this.editable) {
      document.removeEventListener('mousedown', this.handle_click_outside);
    }
  },
  methods: {
    clicked_edit() {
      this.$emit('edit_clicked', 'question_text', this.index);
    },
    handle_click_outside(event) {
      if (!this.editable) {
        return;
      }

      if (is_event_inside_element_with_id(event, this.editor_id)) {
        return;
      }

      this.editing = false;
    },
    text_updated(value) {
      this.$emit('text_updated', this.row, value);
    },
    toggleSelection(value) {
      this.selected = !this.selected;
    }
  },


  data() {
    return {
      local_id: null,
      editing: false,
      local_text: null,
      selected: [],
      show_text: false,
      input_text: null,
    };
  },

};
</script>


<style lang="scss" scoped>

.editable-container {
  min-width: 300px;
  min-height: 12px;
  padding: 8px;
}

:deep .editable-container p {
  padding: 0;
  margin: 0;
  line-height: 1.5;
}

:deep .exp-checkbox-text p {
  margin: 0;
  padding: 0;
}

.editable-container:hover {
  border: 2px solid rgb(50, 201, 50);
}


.question-label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

/* Box wrapper */
.box {
  padding: 15px;
  padding-top: 20px;
  margin-bottom: 4px;
  border: 1px solid #ececec;
  transition: border-color 0.3s, background-color 0.3s;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.selected-box {
  border-color: #0085eb;
  background-color: #f6fdff;
}

.box-header {
  display: flex;
  align-items: center;
  width: 100%;
}

.exp-checkbox-label {
  display: flex;
  align-items: center; /* Ensures checkbox and text are aligned vertically */
  cursor: pointer;
  position: relative;
}

.exp-checkbox-label input {
  opacity: 0;
  width: 0;
  height: 0;
}

.exp-checkbox-custom {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  background-color: #fff;
  border: 2px solid #0085eb;
  border-radius: 4px;
  position: relative;
  transition: background-color 0.2s, border-color 0.2s;
}

.exp-checkbox-label input:checked ~ .exp-checkbox-custom {
  background-color: #0085eb;
  border-color: #0085eb;
}

.exp-checkbox-custom::after {
  content: "";
  position: absolute;
  display: none;
}

.exp-checkbox-label input:checked ~ .exp-checkbox-custom::after {
  display: block;
}

.exp-checkbox-custom::after {
  left: 6px;
  top: 2px;
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

</style>